import { defineComponent as _defineComponent } from 'vue'
import ScaleOut from "@/components/scale-out-component.vue";
//@ts-ignore
import nestedGroupby from "nested-groupby";
import CourseUnitCardItem from "@/components/course-unit-card-item.vue";
import CourseSummaryBanner from "@/components/course-summary-banner.component.vue";

import { onMounted, ref, Ref, computed } from "vue";
import useHttpRequest from "@/composables/use-http-request";
import { useRouter } from "vue-router/composables";
import store from "@/store";
import MyModuleDialog from "@/components/dialogs/my-module-dialog.vue";

import {
  CourseInfo,
  GetStudentCourseInfoDto,
} from "@/dtos/get-student-course-info.dto";


export default /*#__PURE__*/_defineComponent({
  __name: 'my-course-units',
  setup(__props) {

const router = useRouter();
const loading = ref(false);
const loadingError = ref(false);
const courseUnitsModal = ref(false);
const courseInfo: Ref<CourseInfo> = ref({} as CourseInfo);

const getStudentCourseInfo = async () => {
  const request = await useHttpRequest<GetStudentCourseInfoDto>({
    method: "GET",
    url: `students/fetch-course-details/${store.state.userId}`,
    loadingProperty: loading,
    showSuccessMessage: false,
    errorLoadingProperty: loadingError,
  });

  if (!request) return;
  if (
    request.success &&
    request.message == "STUDENT_COURSE_INFO_RETRIEVED_SUCCESSFULLY"
  ) {
    courseInfo.value = request.course_info;
  }
};

onMounted(() => {
  getStudentCourseInfo();
});

const applyForResitsAndRetakes = () => {
  router.push({ path: `my-course-units/failed` });
};

const chooseCourseUnits = () => {
  courseUnitsModal.value = true;
};

const closeChooseCourseUnits = () => {
  courseUnitsModal.value = false;
};

const handleCommand = (command: string) => {
  if (command === "Modules History") {
    router.push({ path: `student-modules-history` });
  }
};

const formattedModules = computed(() => {
  return nestedGroupby(courseInfo.value.course_units, [
    "year_of_study",
    "semester_of_study",
  ]);
});

return { __sfc: true,router, loading, loadingError, courseUnitsModal, courseInfo, getStudentCourseInfo, applyForResitsAndRetakes, chooseCourseUnits, closeChooseCourseUnits, handleCommand, formattedModules, ScaleOut, CourseUnitCardItem, CourseSummaryBanner, MyModuleDialog }
}

})